import { Circle, Clock, CheckCircle2, AlertTriangle, X } from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;
export const getAuth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('access_token') || localStorage.getItem('token')}` } });

export const TASKS_PER_PAGE = 10;

export const REMINDER_OPTIONS = [
  { value: 'none', label: 'No Reminder' },
  { value: '5_min', label: '5 minutes before', minutes: 5 },
  { value: '10_min', label: '10 minutes before', minutes: 10 },
  { value: '15_min', label: '15 minutes before', minutes: 15 },
  { value: '30_min', label: '30 minutes before', minutes: 30 },
  { value: '1_hour', label: '1 hour before', minutes: 60 },
  { value: 'custom', label: 'Custom...' },
];

export const PRIORITY_CONFIG = {
  urgent: { color: 'bg-red-500', text: 'text-red-700', bg: 'bg-red-50', border: 'border-red-200', label: 'Urgent', dot: '#ef4444' },
  high: { color: 'bg-orange-500', text: 'text-orange-700', bg: 'bg-orange-50', border: 'border-orange-200', label: 'High', dot: '#f97316' },
  medium: { color: 'bg-blue-500', text: 'text-blue-700', bg: 'bg-blue-50', border: 'border-blue-200', label: 'Medium', dot: '#3b82f6' },
  low: { color: 'bg-gray-400', text: 'text-gray-600', bg: 'bg-gray-50', border: 'border-gray-200', label: 'Low', dot: '#9ca3af' },
};

export const CATEGORY_CONFIG = {
  follow_up: { icon: '📞', label: 'Follow Up', color: 'text-blue-600' },
  delivery: { icon: '🚗', label: 'Delivery', color: 'text-green-600' },
  documentation: { icon: '📋', label: 'Documentation', color: 'text-purple-600' },
  finance: { icon: '💰', label: 'Finance', color: 'text-amber-600' },
  exchange: { icon: '🔄', label: 'Exchange', color: 'text-teal-600' },
  service: { icon: '🔧', label: 'Service', color: 'text-red-600' },
  custom: { icon: '📌', label: 'Custom', color: 'text-gray-600' },
};

export const STATUS_CONFIG = {
  pending: { icon: Circle, color: 'text-gray-400', label: 'Pending', bg: 'bg-gray-50', headerBg: 'bg-gray-100', headerText: 'text-gray-700' },
  in_progress: { icon: Clock, color: 'text-blue-500', label: 'In Progress', bg: 'bg-blue-50', headerBg: 'bg-blue-100', headerText: 'text-blue-700' },
  completed: { icon: CheckCircle2, color: 'text-green-500', label: 'Completed', bg: 'bg-green-50', headerBg: 'bg-green-100', headerText: 'text-green-700' },
  partial: { icon: AlertTriangle, color: 'text-amber-500', label: 'Partial', bg: 'bg-amber-50', headerBg: 'bg-amber-100', headerText: 'text-amber-700' },
  not_completed: { icon: X, color: 'text-red-400', label: 'Not Done', bg: 'bg-red-50', headerBg: 'bg-red-100', headerText: 'text-red-700' },
};

export const RECURRENCE_OPTIONS = [
  { value: 'none', label: 'No Repeat' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export const KANBAN_COLUMNS = ['pending', 'in_progress', 'completed', 'not_completed'];
